module.exports = __webpack_public_path__ + "img/78.c4d1e9ca.jpg";